import {
  Component,
  computed,
  input,
} from '@angular/core'
import { Entity, EntityTypeMetadata } from './entity-metadata'
import { formatIsoDateOnly } from '../shared/utilities/date'
import { MinMax } from '../shared/models/general'

@Component({
  selector: 'h3[app-entity-title]',
  template: `
    <span class='entity-description'>
      {{ entityDescription() }}
    </span>
    <small>{{ entityTypeName() }}</small>
    @if (effectiveDateRangeMessage()) {
      <small class='date-range'>{{ effectiveDateRangeMessage() }}</small>
    }
  `,
  host: {
    '[class.invisible]': '!visible()',
  },
  styles: `
    .entity-description {
      font-weight: bold;
    }
    small {
      margin-left: 0.5rem;
    }
  `,
})
export class EntityEditorTitleComponent {
  readonly entity = input.required<Entity | undefined>()
  readonly dateRange = input.required<MinMax | undefined>()
  readonly entityTypeMetadata = input.required<EntityTypeMetadata | undefined>()

  protected readonly visible = computed(() =>
    Boolean(this.entity() && this.entityTypeMetadata()))

  readonly entityDescription = computed(() => {
    const entity = this.entity()
    if (entity) {
      const { entity_code, entity_name } = entity
      if (entity_code === entity_name) {
        return entity_name
      } else {
        return `${entity_name} (${entity_code})`
      }
    } else {
      return 'description' // placeholder to set height of invisible title
    }
  })

  readonly entityTypeName = computed(() =>
    this.entityTypeMetadata()?.entity_type_name ?? '',
  )

  protected readonly effectiveDateRangeMessage = computed((): string => {
    const dateRange = this.dateRange()
    if (dateRange) {
      return `(${formatIsoDateOnly(dateRange.min)} -> ${formatIsoDateOnly(dateRange.max)})`
    } else {
      return ''
    }
  })
}
